/**
 * The XML parser will set one K:V for a member that could
 * return multiple entries but only has one.
 */
export var getArrayIfSingleItem = function (mayBeArray) {
    return Array.isArray(mayBeArray) ? mayBeArray : [mayBeArray];
};
